import { FC } from 'react'
import { WidgetSection } from 'modules/Cube/view/common/atomic/WidgetSection'
import {
  Text,
  Checkbox,
  GreyGrey10,
  Popover,
  Primary13Regular,
  TextAreaField,
  TextInputField,
  IconCircleInfo,
  Box,
  Flex
} from '@sequencehq/core-components'
import { PaymentTermsSelect } from 'components/PaymentTerms/PaymentTermsSelect'
import { useInvoiceSettingsWidget } from 'modules/Cube/view/layouts/billingSchedule/widgets/InvoiceSettings/useInvoiceSettingsWidget'

export const InvoiceSettingsWidget: FC = () => {
  const { fieldsConfig } = useInvoiceSettingsWidget()

  return (
    <WidgetSection title="Invoice settings" width="100%">
      <Box padding="0 16px 20px" data-testid="schedule.invoiceSettings">
        <Box
          padding="12px 8px 12px"
          backgroundColor={GreyGrey10}
          borderRadius="6px"
        >
          {/* fit-content so the trimmed-fields VRT clips to the fields, not the
              full-width widget/grey container. */}
          <Box
            as={Flex}
            flexDirection="column"
            gap="16px"
            width="fit-content"
            data-testid="schedule.invoiceSettings.fields"
          >
            {!fieldsConfig.defaultDueDateDays.hidden && (
              <Flex width="235px">
                <PaymentTermsSelect
                  useFieldVariant
                  data-testid="schedule.invoiceSettings.paymentTerms"
                  label="Payment terms"
                  placeholder="Select payment terms"
                  value={fieldsConfig.defaultDueDateDays.value ?? undefined}
                  onChange={fieldsConfig.defaultDueDateDays.onChange}
                  disabled={fieldsConfig.defaultDueDateDays.disabled}
                  validationErrors={
                    fieldsConfig.defaultDueDateDays.validationErrors
                  }
                  customTerms={
                    typeof fieldsConfig.defaultDueDateDays
                      .merchantDefaultValue !== 'undefined'
                      ? [fieldsConfig.defaultDueDateDays.merchantDefaultValue]
                      : []
                  }
                  width="235px"
                />
              </Flex>
            )}

            {!fieldsConfig.memo.hidden && (
              <TextAreaField
                data-testid="schedule.invoiceSettings.memo"
                label="Invoice memo"
                placeholder="Optional memo"
                value={fieldsConfig.memo.value}
                onChange={fieldsConfig.memo.onChange}
                isDisabled={fieldsConfig.memo.disabled}
                validationErrors={fieldsConfig.memo.validationErrors}
                width="470px"
                minHeight="80px"
                resize="vertical"
              />
            )}

            <TextInputField
              label="Purchase order number"
              placeholder="Optional PO number"
              {...fieldsConfig.purchaseOrderNumber}
              onChange={event =>
                fieldsConfig.purchaseOrderNumber.onChange(event?.target?.value)
              }
              width="235px"
            />

            {!fieldsConfig.reference.hidden && (
              <TextInputField
                label="Invoice reference"
                placeholder="Optional reference number"
                {...fieldsConfig.reference}
                onChange={event =>
                  fieldsConfig.reference.onChange(event?.target?.value)
                }
                width="235px"
              />
            )}

            <Flex gap="4px" alignItems="center">
              <Checkbox
                isChecked={fieldsConfig.autoIssueInvoices.value}
                onChange={event => {
                  fieldsConfig.autoIssueInvoices.onChange(event.target.checked)
                }}
                isInvalid={Boolean(
                  fieldsConfig.autoIssueInvoices.validationErrors.length
                )}
                disabled={fieldsConfig.autoIssueInvoices.disabled}
                label={
                  <Text {...Primary13Regular} paddingRight="8px">
                    Auto-send invoices for each billing period
                  </Text>
                }
              />
              <Popover
                header="Auto-send invoices"
                content=" When enabled, Sequence will finalize the invoice and issue
                    it to your customer automatically (including an email
                    notification with the invoice attached as PDF)."
              >
                <IconCircleInfo />
              </Popover>
            </Flex>
          </Box>
        </Box>
      </Box>
    </WidgetSection>
  )
}
